<template>
  <div class="d-flex flex-column" :class="classCustom">
    <label v-if="label" class="h5 font-weight-bold">{{ label }}</label>
    <label>{{ value }}</label>
  </div>
</template>

<script>
export default {
  name: "LabelValue",

  props: {
    label: {
      type: String,
    },
    value: {
      type: String,
    },

    classCustom: {
      type: String,
      default: ""
    }
  }
}
</script>
